import React, { PureComponent, PropTypes } from 'react';
import { connect } from 'react-redux';
import { Field } from 'redux-form';
import { selectBankOptions } from '../../../redux/modules/banks/selectors';
import { Input, Select, VERTICAL_GROUP } from '../../../components/Form';


class Accounts extends PureComponent {
  static propTypes = {
    banks: PropTypes.array.isRequired,
    fields: PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props);

    this.addAccount = this.addAccount.bind(this);
  }

  addAccount() {
    this.props.fields.push({});
  }

  render() {
    const { fields, banks } = this.props;

    return (
      <fieldset className="form-group">
        <legend>Bankas konti</legend>
        <div className="list-group">
          {fields.map((account, idx) =>
            <fieldset className="list-group-item" key={idx}>
              {fields.length > 1 && (
                <button className="btn btn-link remove-btn" onClick={_ => fields.remove(idx)}>
                  <i className="fa fa-times text-danger"/>
                </button>
              )}
              <div className="row">
                <div className="col-6">
                  <Field
                    component={Select}
                    label="Banka"
                    placeholder="Banka"
                    name={`${account}.bank`}
                    group={{direction: VERTICAL_GROUP}}
                    options={banks}
                  />
                </div>
                <div className="col-6">
                  <Field
                    component={Input}
                    label="Konts"
                    name={`${account}.number`}
                    group={{direction: VERTICAL_GROUP}}
                  />
                </div>
              </div>
            </fieldset>
          )}
        </div>
        { fields.length < 3 && (
          <button className="btn btn-sm btn-primary pull-right" onClick={this.addAccount}>
            <i className="fa fa-plus" /> Pievienot kontu
          </button>
        )}
      </fieldset>
    )
  }
}

const mapStateToProps = (state, props) => ({
  banks: selectBankOptions(state, props)
});

export default connect(mapStateToProps)(Accounts);



// WEBPACK FOOTER //
// ./src/scenes/Registration/CompanyForm/Accounts.js